// extracted by mini-css-extract-plugin
export default {"numberContainer":"NumberInput_numberContainer__PnuSD","numberInput":"NumberInput_numberInput__VTTzt"};